/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var RotateSquareLeftIcon16Solid = forwardRef('RotateSquareLeftIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.781.164a.75.75 0 1 1 .938 1.172L8.889 2h2.361A3.75 3.75 0 0 1 15 5.75v3a.75.75 0 0 1-1.5 0v-3a2.25 2.25 0 0 0-2.25-2.25H8.888l.83.664a.75.75 0 1 1-.937 1.172L7.014 3.92a1.5 1.5 0 0 1 0-2.342L8.78.164Z" }),
        React.createElement("path", { d: "M12 8.5A2.5 2.5 0 0 0 9.5 6h-5A2.5 2.5 0 0 0 2 8.5v5A2.5 2.5 0 0 0 4.5 16h5a2.5 2.5 0 0 0 2.5-2.5v-5Z" })));
});
